export default function (value: string | null, maxLength: number) {
  if (value && value.length > maxLength) {
    return value.substring(0, maxLength - 3) + '...';
  }
  return value;
}
